import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { LocaleDatePipe } from '@app/pipes/locale-date.pipe';
import { DashboardFilterType } from '@app/reducers/page-filters/page-filters-dashboard.config';
import { selectAllowedDashboardFilter } from '@app/reducers/page-filters/page-filters-dashboard.selectors';
import { Store } from '@ngrx/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AppState } from '@reducers/interfaces';
import { PageFiltersService } from '@reducers/page-filters/page-filters.service';
import { mgcIconCelebrateCuteRe } from '@sb/mgc-icons/mgcIcon-celebrate_cute_re.icon';
import { DashboardWidgetModule } from '@sb/ui/dashboard-widget/dashboard-widget.module';
import { IconRegistry } from '@sb/ui/icon';
import { toISODateString } from '@shiftbase-com/ts-shared/utilities';
import { addWeeks } from 'date-fns';

import { getEmployeeBirthdaysInPeriod } from '../widget.helper';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'upcoming-birthdays-widget',
  templateUrl: './upcoming-birthdays-widget.component.html',
  imports: [DashboardWidgetModule, TranslatePipe, LocaleDatePipe],
})
export class UpcomingBirthdaysWidgetComponent {
  private store = inject<Store<AppState>>(Store);
  private pageFilterService = inject(PageFiltersService);
  private iconRegistry = inject(IconRegistry);
  private translate = inject(TranslateService);

  periodOptions = [
    { label: this.translate.instant('week'), value: 1 },
    { label: this.translate.instant('2 weeks'), value: 2 },
    { label: this.translate.instant('3 weeks'), value: 3 },
    { label: this.translate.instant('4 weeks'), value: 4 },
  ];

  birthdays = computed(() =>
    this.store.selectSignal(
      getEmployeeBirthdaysInPeriod(
        toISODateString(new Date()),
        toISODateString(addWeeks(new Date(), this.widgetPeriod())),
      ),
    )(),
  );

  private filterType = DashboardFilterType.BIRTHDAYS;
  private dashboardFilter = this.store.selectSignal(selectAllowedDashboardFilter(this.filterType));
  widgetPeriod = computed(() => this.dashboardFilter()?.widgetPeriod ?? 1);

  constructor() {
    this.iconRegistry.registerIcons([mgcIconCelebrateCuteRe]);
  }

  onPeriodChange(period: number | string) {
    this.pageFilterService.setFilter('dashboard', this.filterType, {
      widgetPeriod: period,
    });
  }
}
